import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

// Diálogo de confirmação para ações sensíveis/destrutivas.
export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = "Confirmar", cancelLabel = "Cancelar", destructive = false, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="border-line bg-popover" data-testid="confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-heading">{title}</AlertDialogTitle>
        {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-cancel" className="border-line bg-transparent hover:bg-white/5">{cancelLabel}</AlertDialogCancel>
        <AlertDialogAction
          data-testid="confirm-accept"
          onClick={onConfirm}
          className={cn(destructive ? "bg-err text-white hover:bg-err/90" : "bg-brand text-white hover:bg-brand-hover")}
        >
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
